<template>
<div class="chapter">
<div class="inner_page">
<div class="cover">
<img alt="cover" src="images/9780374304836.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?326c8b6f